/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';
// import {language} from './language.js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger,
        breakpointMaxM = 1920,
        resizeTimer;

        const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent',
        mobileMenuTriggerSelector = '.mm-trigger';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        breakpointMaxM = 768;

        let mobileMenuExtras;
        let mobileMenuNavbar;
        const menu = new Mmenu(mobileMenuSelector, {
            // options
            'extensions': [
                'position-right',
                'pagedim-black',
                'border-full',
                'theme-dark',
                'fx-menu-slide',
                'custom-width'
            ],
            hooks: {
                "openPanel:before": (panel) => {
                    const parser = new DOMParser();
                    const panelContent = parser.parseFromString(panel.innerHTML, "text/html");
                    const mobileMenuExtraElement = panelContent.querySelector('.mobile-menu__meta-menu');
                    const mobileMenuNavbarElement = panelContent.querySelector('.mobile-menu__navbar');
                    const panelDOMElement = document.getElementById(panel.id);

                    if(mobileMenuExtraElement) {
                        mobileMenuExtras = mobileMenuExtraElement;
                    }else if(mobileMenuExtras) {
                        panelDOMElement.querySelector('.mm-listview').append(mobileMenuExtras);
                    }

                    panelDOMElement.querySelector('.mm-navbar__title').innerHTML = "";

                    //Insert language selector
                    if(!panelDOMElement.querySelector('.mm-navbar').querySelector('.language-selector')) {
                        const languageSelector = document.querySelector('.language-selector').cloneNode(true);
                            panelDOMElement.querySelector('.mm-navbar').appendChild(languageSelector);
                    }

                    //Insert closing button
                    if(!panelDOMElement.querySelector('.mm-navbar').querySelector('.menu-nav-mobile__btn')) {
                        const mobileNavToggle = document.querySelector('.menu-nav-mobile__btn').cloneNode(true);
                            panelDOMElement.querySelector('.mm-navbar').appendChild(mobileNavToggle);
                    }
                }
            }
        }, {
            // configuration
            offCanvas: {
                page: {
                    nodetype: 'main',
                    selector:mainContentSelector
                }
            },
            classNames: {
                selected: 'custom-mm-selected',
                panel: 'custom-mm-panel'
            }
        });

        // Init mmenu api
        const mmenuApi = menu.API;

        // Toggle menu
        document.addEventListener("click", (e) => {
            const mobileMenuTrigger = e.target.closest(mobileMenuTriggerSelector);
            if (mobileMenuTrigger) {
              if(document.body.classList.contains('mm-wrapper_opened')) {
                mmenuApi.close();
              }else {
                mobileMenu.setAttribute('style', '');
                mmenuApi.open();
              }
            }
          });

        // Close mmenu if screen width gets over breakpointMaxM (768px)
        window.addEventListener('resize', e => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                const width = document.body.clientWidth;
                const mmIsOpened = document.querySelector('body').classList.contains('mm-wrapper_opening');
                if (mmenuApi && mmIsOpened && width > breakpointMaxM) {
                    mmenuApi.close();
                }
            }, 250);
        });
    };

    init();
}
